export default "__VITE_ASSET__CcAfy5vq__"